import React, { Component } from "react"
import _ from 'lodash';
import { connect } from "react-redux"
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { reduxForm, formValueSelector, Field, getFormSyncErrors, change } from 'redux-form'
import { Col, FormGroup, ControlLabel, Row } from "react-bootstrap";
import {
  deleteAdvancer, resendAdvancerEmail, deleteAlternate, resetWizardState,
  savePostEventAdvancers, updateAlternatesOrder, fetchAdvancerParentEmail, setSearchMode
} from '../../../../redux/actions/action_postEvent';
import { blue, gray, warning, StatusDescription } from '../../../../utils/constants'
import { STEP_SEQUENCE } from '../../logic';
import Advancers from "./advancers";
import Alternates from "./alternates";
import NewAdvancerAlternate from "./newAdvancerAlternate"
import UpdateAdvancers from "./updateAdvancers"
import UpdateAlternates from "./updateAlternates"

const formName = 'postevent'

const sectionBorder = {
  border: `1px solid ${gray}`,
  padding: '15px',
  marginRight: '0px',
  marginBottom: '15px'
};

const memberTypes = {
  Advancer: 'Advancer',
  Alternate: 'Alternate'
}

class RecordAdvancersAlternates extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tableView: true,
      memberType: '',
      currentBowlerAdding: '',
      advancer: []
    }
    this.handleResetError = this.handleResetError.bind(this);
    this.handleAddAdvancer = this.handleAddAdvancer.bind(this)
    this.handleAddAlternate = this.handleAddAlternate.bind(this)
    this.handleViewChange = this.handleViewChange.bind(this)
    this.divisionHeldOptions = this.divisionHeldOptions.bind(this)
    this.handleOnDeleteAdvancer = this.handleOnDeleteAdvancer.bind(this)
    this.handleOnDeleteAlternate = this.handleOnDeleteAlternate.bind(this)
    this.saveRecordAdvancers = this.saveRecordAdvancers.bind(this)
    this.handleUpdateAdvancer = this.handleUpdateAdvancer.bind(this)
    this.handleOnResendAdvancerEmail = this.handleOnResendAdvancerEmail.bind(this)
    this.handleUpdateAlternate = this.handleUpdateAlternate.bind(this)
    this.handleMoveUp = this.handleMoveUp.bind(this)
    this.handleMoveDown = this.handleMoveDown.bind(this)
    this.handleAdvancerUpdatedData = this.handleAdvancerUpdatedData.bind(this)
    this.handleAlternateUpdatedData = this.handleAlternateUpdatedData.bind(this)
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.props.dispatch(resetWizardState(STEP_SEQUENCE.Advancers));
  }

  handleResetError() {
    const { syncErrors, dispatch } = this.props;
    if (syncErrors) {
      dispatch(change(formName, 'syncErrors', null))
    }
  }

  handleAddAdvancer = () => {
    this.setState({
      tableView: false,
      memberType: memberTypes.Advancer
    })
  }

  handleMoveUp = (newAlternateList) => {
    const { dispatch } = this.props;
    dispatch(updateAlternatesOrder(newAlternateList));
  }

  handleMoveDown = (newAlternateList) => {
    const { dispatch } = this.props;
    dispatch(updateAlternatesOrder(newAlternateList));
  }

  handleUpdateAlternate = (alternateId) => {
    const { mixedAgeDivisionsHeld, divisionHeldId } = this.props
    const divisionHeld = _.find(mixedAgeDivisionsHeld, { id: parseInt(divisionHeldId) });
    let alternates = [];
    alternates = divisionHeld.alternates;
    const {
      eventId,
      parentGuardianEmail,
      membershipId
    } = _.find(alternates, { id: parseInt(alternateId) });
    const membershipStringSplit = membershipId.split("-");
    const memberidprefix = membershipStringSplit[0];
    const memberidsuffix = membershipStringSplit[1];
    const alternate = {
      alternateId: alternateId,
      eventId: eventId,
      parentGuardianEmail: parentGuardianEmail,
      memberidprefix: memberidprefix,
      memberidsuffix: memberidsuffix
    }
    const oneAlternate = [];
    oneAlternate.push(alternate);
    this.setState({
      tableView: false,
      memberType: 'UpdateAlternate',
      alternate: oneAlternate
    });
  }

  handleUpdateAdvancer = (advancerId) => {
    const { mixedAgeDivisionsHeld, divisionHeldId } = this.props
    const divisionHeld = _.find(mixedAgeDivisionsHeld, { id: parseInt(divisionHeldId) });
    let advancers = [];
    advancers = divisionHeld.advancers;
    const {
      eventId,
      parentGuardianEmail,
      membershipId
    } = _.find(advancers, { id: parseInt(advancerId) });
    const membershipStringSplit = membershipId.split("-");
    const memberidprefix = membershipStringSplit[0];
    const memberidsuffix = membershipStringSplit[1];
    const advancer = {
      advancerId: advancerId,
      eventId: eventId,
      parentGuardianEmail: parentGuardianEmail,
      memberidprefix: memberidprefix,
      memberidsuffix: memberidsuffix
    }

    const oneAdvancer = [];
    oneAdvancer.push(advancer);
    this.setState({
      tableView: false,
      memberType: 'UpdateAdvancer',
      advancer: oneAdvancer
    });
  }

  handleAddAlternate = () => {
    this.setState({
      tableView: false,
      memberType: memberTypes.Alternate
    })
  }

  handleViewChange(isCurrentValue) {

    const { tableView, currentBowlerAdding } = this.state;
    if ((isCurrentValue) || currentBowlerAdding) {
      this.setState({ currentBowlerAdding: isCurrentValue });
    }
    if (tableView) {
      this.setState({
        tableView: false
      });
    } else {
      this.setState({
        tableView: true
      });
    }
  }

  handleOnResendAdvancerEmail(advancerId) {
    const { dispatch, mixedAgeDivisionsHeld, divisionHeldId } = this.props
    const divisionHeld = _.find(mixedAgeDivisionsHeld, { id: parseInt(divisionHeldId) });
    const advancers = _.find(divisionHeld.advancers, { id: parseInt(advancerId) });
    const advancer = {
      eventId: advancers.eventId,
      addressLine1: advancers.addressLine1,
      addressLine2: advancers.addressLine2,
      dob: advancers.dob,
      city: advancers.city,
      country: advancers.country,
      phoneNumber: advancers.phoneNumber,
      emailAddress: advancers.emailAddress,
      firstName: advancers.firstName,
      lastName: advancers.lastName,
      state: advancers.state,
      zip: advancers.zip,
      calculatedDivision: advancers.calculatedDivision,
      parentGuardianEmail: advancers.parentGuardianEmail
    }
    this.setState({
      advancer: advancer,
      memberType: 'ResendEmail'
    });
    dispatch(resendAdvancerEmail(advancer.eventId, advancer));
  }
  handleAdvancerUpdatedData(advancer) {
    this.setState({
      advancer: advancer,
      memberType: 'updatedAdvancer'
    });
  }
  handleAlternateUpdatedData(alternate) {
    this.setState({
      alternate: alternate,
      memberType: 'updatedAlternate'
    });
  }
  handleOnDeleteAdvancer(advancerId) {
    const { dispatch, eventId, divisionHeldId } = this.props
    dispatch(deleteAdvancer(advancerId, eventId, divisionHeldId));
  }

  handleOnDeleteAlternate(alternateId) {
    const { dispatch, eventId, divisionHeldId } = this.props
    dispatch(deleteAlternate(alternateId, eventId, divisionHeldId));
  }

  divisionHeldOptions() {
    const { mixedAgeDivisionsHeld } = this.props
    const divisionsHeldArray = Object.values(mixedAgeDivisionsHeld)
    const option = divisionsHeldArray.map((division) => {
      return (<option key={division.id} value={division.id}>{division.name}</option>)
    })
    return option
  }

  saveRecordAdvancers() {
    const { mixedAgeDivisionsHeld, dispatch, eventId } = this.props;
    dispatch(savePostEventAdvancers(eventId, mixedAgeDivisionsHeld));
  }

  generateUpdateErrors(errors) {
    const error = errors.map((key, index) => {
      return (<li key={index} style={{ color: warning }}>{this.props.syncErrors[key]}</li>)
    })
    return error;
  }
  generateIsAdvancerError(isAdvancer) {
    const { currentBowlerAdding, memberType } = this.state;
    if (isAdvancer > 0)
      return (<li key={956} style={{ color: warning }}>Bowler has previously advanced ( {currentBowlerAdding} ). Please select another {memberType.toLowerCase()}. </li>)
  }
  render() {
    const { tableView, memberType, advancer, alternate } = this.state
    const { divisionHeldId, currentWizardStep, componentStateSaved, syncErrors,
            saveComponentState, eventname, mixedAgeDivisionsHeld, isAdvancerCurrently, roleName, status } = this.props

    let advancers = []
    let alternates = []
    let numberAdvancers = 0
    const isDivisionSelected = (divisionHeldId !== undefined) && (divisionHeldId !== '-1' && divisionHeldId > 0)
    const errors = Object.keys(syncErrors);
    const isAdministrator = roleName == 'Administrator';

    if (divisionHeldId !== undefined) {
      const divisionHeld = _.find(mixedAgeDivisionsHeld, { id: parseInt(divisionHeldId) });
      if (divisionHeld !== undefined) {
        advancers = divisionHeld.advancers;
        alternates = divisionHeld.alternates;
        numberAdvancers = divisionHeld.numberAdvancers;
      }
    }

    if (currentWizardStep === STEP_SEQUENCE.Advancers) {
      if ((saveComponentState === true) && (componentStateSaved === false) && errors.length == 0) {
        this.saveRecordAdvancers();
      }
      if (componentStateSaved === true) {
        this.props.onComponentStateSaved(componentStateSaved)
      }
      if (errors.length > 0) {
        this.props.onComponentStateSaved(false)
      }
    }
    return (
      <div style={{ marginTop: '1%' }} sm={12}>
        <form className="form-horizontal" sm={12} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
          <Row>
            <Col sm={12} >
              {
                errors.length > 0 && tableView &&
                (<Col sm={12} style={sectionBorder}>
                  <h4 style={{ color: warning }}>* Please correct the following errors to proceed:</h4>
                  <ul>
                    {
                      this.generateUpdateErrors(errors)
                    }
                    {
                      this.generateIsAdvancerError(isAdvancerCurrently)
                    }
                  </ul>
                </Col>)
              }
              <FormGroup style={{ padding: '0 0 15px 25px', margin: '0' }}>
                <h4 className='text-left' style={{ color: blue }}>{' '}Event Name - {eventname}</h4>
              </FormGroup>
              {
                tableView &&
                <div className="stacked-filter-panel">
                  <FormGroup controlId="searchby" className="searchby-filter">
                    <ControlLabel style={{ minWidth: '105px' }}>Division Held:</ControlLabel>
                    <Field name='divisionHeldId'
                      component="select"
                      style={{ width: '225px' }}
                      value={divisionHeldId}
                      className="form-control"
                    >
                      <option value='-1'>Select a Division...</option>
                      {this.divisionHeldOptions()}
                    </Field>
                  </FormGroup>
                </div>
              }
              <FormGroup style={{ padding: '0 0 5px 5px', margin: '0' }}>
                {
                  tableView == true && isDivisionSelected &&
                  <div>
                    <div className='col-sm-5'>
                      <Advancers
                        advancers={advancers}
                        advancerUpdateInfo={this.state}
                        onDeleteAdvancer={this.handleOnDeleteAdvancer}
                        onAddAdvancer={this.handleAddAdvancer}
                        onUpdateAdvancer={this.handleUpdateAdvancer}
                        onResendEmail={this.handleOnResendAdvancerEmail}
                        numberSpots={numberAdvancers}
                        disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)} />
                    </div>
                    <div className='col-sm-5'>
                      <Alternates
                        alternates={alternates}
                        alternateUpdateInfo={this.state}
                        onDeleteAlternate={this.handleOnDeleteAlternate}
                        onAddAlternate={this.handleAddAlternate}
                        onUpdateAlternate={this.handleUpdateAlternate}
                        onMoveUp={this.handleMoveUp}
                        onMoveDown={this.handleMoveDown}
                        numberSpots={numberAdvancers}
                        disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)} />
                    </div>
                  </div>
                }
                {tableView == false && (memberType == 'Advancer' || memberType == 'Alternate') &&
                  <div className='col-sm-12'>
                    <NewAdvancerAlternate
                      onSave={this.handleViewChange}
                      onCancel={this.handleViewChange}
                      onRefresh={this.handleRefreshAthletes}
                      athleteType={memberType} />
                  </div>
                }
                {
                  tableView == false && memberType == 'UpdateAdvancer' && advancer.length > 0 &&
                  <div className='col-sm-12'>
                    <UpdateAdvancers
                      advancerUpdateData={this.state}
                      onUpdateCancel={this.handleViewChange}
                      onUpdateSave={this.handleViewChange}
                      onAdvancerUpdatedData={this.handleAdvancerUpdatedData}
                    />
                  </div>
                }
                {
                  tableView == false && memberType == 'UpdateAlternate' && alternate.length > 0 &&
                  <div className='col-sm-12'>
                    <UpdateAlternates
                      alternateUpdateData={this.state}
                      onAlternateUpdateCancel={this.handleViewChange}
                      onAlternateUpdateSave={this.handleViewChange}
                      onAlternateUpdatedData={this.handleAlternateUpdatedData}
                    />
                  </div>
                }
              </FormGroup>
            </Col>
          </Row>
        </form>
      </div >)
  }
}

function validate(values) {
  const {
    divisionHeldId,
    mixedAgeDivisionsHeld,
    updateRecordAdvancersErrors
  } = values;

  const errors = [];

  const divisionHeld = _.find(mixedAgeDivisionsHeld, { id: parseInt(divisionHeldId) });

  if (!divisionHeld) {
    ErrorCollection(errors, updateRecordAdvancersErrors, mixedAgeDivisionsHeld);
    return errors.length > 0 ? errors : {};
  }

  const advancers = Array.isArray(divisionHeld.advancers) ? divisionHeld.advancers : [];
  const alternates = Array.isArray(divisionHeld.alternates) ? divisionHeld.alternates : [];
  const numberAdvancers = parseInt(divisionHeld.numberAdvancers) || 0;

  if (advancers.length < numberAdvancers) {
    errors.push(`All advancer spots must be filled out for division: ${divisionHeld.name}`);
  }

  if (alternates.length < numberAdvancers) {
    errors.push(`All alternate spots must be filled out for division: ${divisionHeld.name}`);
  }

  if (errors.length === 0) {
    ErrorCollection(errors, updateRecordAdvancersErrors, mixedAgeDivisionsHeld);
  }

  return errors.length > 0 ? errors : {};
}

function ErrorCollection(errors, updateRecordAdvancersErrors, mixedAgeDivisionsHeld) {
  Object.values(updateRecordAdvancersErrors || {}).forEach(raw => {
    const message = Array.isArray(raw) && raw.length === 1 ? raw[0] : raw;
    if (typeof message !== 'string') {
      errors.push(message);
      return;
    }

    const isAdvancerError = message.includes('advancer');
    const isAlternateError = message.includes('alternate');
    const match = message.match(/division:\s(.+)$/);
    const divisionName = match && match[1] ? match[1].trim() : null;

    if (!divisionName || (!isAdvancerError && !isAlternateError)) {
      errors.push(message);
      return;
    }

    const divisionHeld = _.find(mixedAgeDivisionsHeld, d => d.name === divisionName);
    if (!divisionHeld) {
      errors.push(message);
      return;
    }

    const { advancers = [], alternates = [], numberAdvancers = 0 } = divisionHeld;
    const isStillInvalid =
      (isAdvancerError && advancers.length < numberAdvancers) ||
      (isAlternateError && alternates.length < numberAdvancers);

    if (isStillInvalid) {
      errors.push(message);
    }
  });
}

RecordAdvancersAlternates.propTypes = {
  dispatch: PropTypes.func,
  eventId: PropTypes.number,
  divisionHeldId: PropTypes.string,
  onComponentStateSaved: PropTypes.func,
  componentStateSaved: PropTypes.bool,
  currentWizardStep: PropTypes.number,
  saveComponentState: PropTypes.bool,
  mixedAgeDivisionsHeld: PropTypes.array,
  eventname: PropTypes.string,
  isAdvancerCurrently: PropTypes.number,
  syncErrors: PropTypes.object,
  roleName: PropTypes.string,
  status: PropTypes.string
}

function mapStateToProps(state, ownProps) {
  const formName = ownProps.form;
  const selector = formValueSelector(formName);
  const syncErrors = getFormSyncErrors(formName)(state);
  const eventId = selector(state, 'eventId');
  const componentStateSaved = selector(state, 'componentStateSaved');
  const currentWizardStep = selector(state, 'currentWizardStep');
  const mixedAgeDivisionsHeld = selector(state, 'mixedAgeDivisionsHeld');
  const eventname = selector(state, 'eventname');
  const saveAdvancersError = selector(state, 'saveAdvancersError');
  const divisionHeldId = selector(state, 'divisionHeldId');
  const isAdvancerCurrently = selector(state, 'isAdvancerCurrently');
  const status = selector(state, 'status');
  const parentEmailAddress = selector(state, 'parentEmailAddress');
  const roleName = state.user.roleName
  return {
    eventId,
    componentStateSaved,
    currentWizardStep,
    mixedAgeDivisionsHeld,
    eventname,
    saveAdvancersError,
    divisionHeldId,
    isAdvancerCurrently,
    syncErrors,
    roleName,
    status,
    parentEmailAddress
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    deleteAdvancer,
    fetchAdvancerParentEmail,
    resendAdvancerEmail,
    deleteAlternate,
    resetWizardState,
    savePostEventAdvancers,
    updateAlternatesOrder,
    setSearchMode
  }, dispatch)
}

export default reduxForm({
  validate,
  form: formName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(RecordAdvancersAlternates))



// WEBPACK FOOTER //
// ./src/containers/postevent/components/recordAthletes/index.js